import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="home-footer">
      <div className="footer-content">
        <div className="footer-links">
          <a href="https://x.com/REDDICKS_XRD" target="_blank" rel="noopener noreferrer" className="footer-link">Twitter</a>
          <a href="https://t.me/RedDicks_XRD" target="_blank" rel="noopener noreferrer" className="footer-link">Telegram</a>
        </div>
        <div className="copyright">
          <p>© 2025 Reddicks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 